<template>
  <div v-loading="talentLoading" style="min-height: 200px">
    <div v-if="personData && personData.length && !talentLoading">
      <div class="person-item" v-for="(item,i) in personData" :key="i" @click="goDetails(item.scholarId)">
        <el-avatar fit="cover" style="min-width:52px" :size="52" :src="item.avatar" @error="errorHandler">
          <img src="https://img01.zhitulist.com/avatars/e79129a26c564bc3856ec9b680048103.jpg" alt="" />
        </el-avatar>
        <div style="margin-left: 8px">
          <div class="person-name">{{ item.scholarVO.scholarName }}</div>
          <div class="item-left ellipsis">所在机构:<span class="item-right" :title="item.scholarVO.scholarOrg">{{ item.scholarVO.scholarOrg || '-' }}</span></div>
          <div class="item-left ellipsis" v-if="item.scholarVO.fields && item.scholarVO.fields.length">研究领域:<span class="item-right" :title="item.scholarVO.fields.map(field => field.name).join(',')">{{ item.scholarVO.fields.map(field => field.name).join(',') }}</span></div>
          <div class="item-left" v-else>研究领域:<span class="item-right">-</span></div>
          <div class="item-left">
            成果数:<span class="item-num" style="margin-right: 5px">{{ item.publications_count || 0 }}</span>
            H指数:<span class="item-num" style="margin-right: 5px">{{ item.hindex || 0 }}</span>
            引用数:<span class="item-num" >{{ item.citedby || 0 }}</span>
          </div>
          <div class="item-left flex items-center" style="margin-top: 5px">个人主页:
            <div
              style="width: 26px; height: 26px; border-radius: 50%; background-color: #1241C9;margin-left: 10px"
              :style="{ backgroundColor: item.person_url ? '#1241C9' : '#999999' }"
              class="pointer flex justify-center items-center"
              @click.stop="goInfoUrl(item.person_url)"
            >
              <img
                width="14px"
                height="14px"
                :src="require('@/assets/images/talent/boshi.png')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'personList',
  components: {},
  props: ["personData",'talentLoading'],
  data() {
    return {

    }
  },
  created() {},
  methods: {
    goInfoUrl(url) {
      if (url) {
        window.open(url);
      }
    },
    goDetails(id) {
      if (!id) {
        this.$message.warning('暂无详情数据');
        return false;
      }
      let obj = {
        name: 'talentDetail',
        query: { id },
      };
      let routeData = this.$router.resolve(obj);
      window.open(routeData.href, '_blank');
    },
    errorHandler() {
      return true
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">

.person-item{
  margin: 5px 19px;
  display: flex;
  cursor: pointer;
  padding: 15px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DEE2E9;

  .person-name{
    font-weight: 500;
    font-size: 18px;
    color: #181F33;
  }
  .item-left{
    margin-top: 10px;
    width: 230px;
    line-height: 20px;
    font-size: 14px;
    white-space: nowrap;
    color: #8191B2;
  }
  .item-right{
    font-size: 14px;
    //white-space: pre-wrap; /* 保留空格且自动换行 */
    word-break: break-all;
    line-height: 20px;
    max-width: 200px;
    color: #50607F;
    margin-left: 8px;
  }

  .item-num{
    font-size: 14px;
    color: #3860F4;
    margin-left: 3px;
  }
}

</style>
